

































































































import { Component, Vue } from "vue-property-decorator";
import { Button, Dialog, Toast, Popup, Picker, Loading, Icon, Checkbox } from "vant";
import customField from "@/components/customField/index.vue";
import PsdSettingDialog from './PsdSettingDialog.vue'
import { isChinaPhone, isHKPhone } from "@/utils/verify";

@Component({
  name: "MessageArea",
  components: {
    PsdSettingDialog,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Loading.name]: Loading,
    [Icon.name]: Icon,
    [Checkbox.name]: Checkbox,
    [customField.name]: customField
  }
})
export default class Login extends Vue {
  form: any = {
    zone_code: "852",
    phone: "",
    captcha: "",
    code: "",
    key: "",
    login_type: 2, //1密码，2短信
    where_type: 1, // 1: idc H5登录注册 0: 高盈金融 H5登录注册
  };
  img = "";
  isSendVerCode = false;
  verCodeTime = 120;
  verCodeTimer: any = null;
  showZoneCodePicker = false;
  zoneCodeColumns:any = [
  ];
  isCaptchaLoading = true;
  isCaptchaError = false;
  isRegister = false;
  isAgree = false;
  showPsdDialog = false;

  get isDisabledSubmit() {
    let flag = false;
    for (const key in this.form) {
      if (!this.form[key] && key !== "key") {
        flag = true;
        break;
      }
    }
    return flag;
  }

  created() {
    this.zoneCodeColumns = [
      {
        text: this.$t('mki18n.t00005'),
        value: "852"
      },
      {
        text: this.$t('mki18n.t00006'),
        value: "86"
      }
    ];
    this.handleGetCaptcha();
  }

  handleGetCaptcha() {
    this.isCaptchaLoading = true;
    this.isCaptchaError = false;
    (this as any).$apis
      .getCaptcha()
      .then(res => {
        
        this.isCaptchaLoading = false;
        const { key, img } = res;
        this.form.key = key;
        this.img = img;
      })
      .catch(e => {
        this.isCaptchaLoading = false;
        this.isCaptchaError = true;
        
      });
  }

  handleConfirmZoneCode(item) {
    this.form.zone_code = item.value;
    this.showZoneCodePicker = false;
  }

  verifyPhone() {
    if (this.form.zone_code == "86") {
      return isChinaPhone(this.form.phone);
    } else if (this.form.zone_code == "852") {
      return isHKPhone(this.form.phone);
    }
  }

  // 点击发送短信按钮
  handleSendVerCode() {
    const { captcha, key } = this.form;
    if (!this.verifyPhone()) return this.$toast.fail("请输入正确的手机号");
    if (!this.form.captcha) return this.$toast.fail("请填写图片验证码");
    const params = {
      captcha,
      key
    };
    (this as any).$apis
      .verifyCaptcha(params)
      .then(res => {
        
        this.sendVerCode();
      })
      .catch(e => {
        
      });
  }

  // 发送短信
  sendVerCode() {
    const { phone, zone_code } = this.form;
    const params = {
      phone,
      zone_code,
      msg_show: 1,
      type: 6 // 6：idc上h5登录注册
    };
    (this as any).$apis
      .sendVerCode(params)
      .then(res => {
        Toast(this.$t("common.message_send_success_text"));
        const { code, is_register } = res;
        this.form.code = code;
        this.isRegister = !is_register;
        this.isSendVerCode = true;
        this.setIntervalSendCode();
        
      })
      .catch(e => {
        
      });
  }

  setIntervalSendCode() {
    const now = new Date().getTime();
    const end = new Date(now + this.verCodeTime * 1000).getTime();
    this.verCodeTimer = setInterval(() => {
      this.verCodeTime = Math.ceil((end - new Date().getTime()) / 1000);
      if (this.verCodeTime <= 0) {
        clearInterval(this.verCodeTimer);
        this.verCodeTime = 120;
        this.isSendVerCode = false;
      }
    }, 1000);
  }

  // 登录或注册
  handleSubmit() {
    if (!this.verifyPhone()) return this.$toast.fail("请输入正确的手机号");
    if(this.isRegister && !this.isAgree) return this.$toast.fail("请阅读并勾选协议");

    if(this.isRegister){
      this.doRegister();
    }else {
      this.doLogin();
    }
  }

  // 注册
  doRegister(){
    (this as any).$apis
      .checkRegister(this.form)
      .then(res => {
        this.showPsdDialog = true;
        
      })
      .catch(e => {
        
      });
  }

  // 登录
  doLogin(){
    (this as any).$apis
      .login(this.form)
      .then(res => {
        
        const { token, user_info } = res;
        (this as any).$localstorage.set("userInfo", user_info);
        sessionStorage.setItem("token", token);
        this.$router.go(-1);
      })
      .catch(e => {
        
      });
  }
}
